module.exports = __webpack_public_path__ + "static/media/hipercard.6f7d4c23.svg";